module.exports = __webpack_public_path__ + "assets/img/headerlogo.06f02805.png";